import screenbanner from "./images/background/1.jpg";
import mobilebanner from "./images/background/2.jpg";


import neo from './images/property/neo.jpg'

import divino from './images/property/divino.jpg'

export const BannerData = {
  screenbanner: screenbanner,
  mobilebanner: mobilebanner,
};

export const LocationData = {
  taglineheading: "Property In South Mumbai",
  locationtag: "",
  location: [

    // {
    //   name: "Casa Venero",
    //   image: divino,
    //   price: "On Request",
    //   location: "Alibaug",
    //   bed: "4 BHK ",
    //   size: "700 Sq. yd.",
    //   url: `/casa-venero`,
    // },
    {
      name: "Lodha Divino",
      image: divino,
      price: "On Request ",
      location: "Matunga",
      bed: " 2,3 & 4 BHK ",
      size: "858 Sq. Ft.",
      url: `/lodha-divino`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Neo Liv",
      image: neo,
      price: "On Request",
      location: "Alibaug",
      bed: " Villa & Plots ",
      size: "2200 Sq. Ft.",
      url: `/neo-liv-alibaug`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    

  ],
};